import * as Sentry from '@sentry/react';

const dsn = (process.env.REACT_APP_SENTRY_DSN || '').trim();

// Offline-first: los fallos de red por falta de cobertura son NORMALES, no incidencias.
const RUIDO = /failed to fetch|networkerror|load failed|aborterror|network request failed|offline|chunkloaderror|loading chunk|typeerror: cancelled/i;

export function initSentry() {
  if (!dsn) return; // sin DSN => Sentry desactivado (no-op), la app arranca igual
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    sendDefaultPii: false,
    beforeSend(event, hint) {
      const vals = (event.exception?.values || []).flatMap((v) => [v.type, v.value]).filter(Boolean).join(' ');
      const o = hint?.originalException;
      const ot = o instanceof Error ? `${o.name}: ${o.message}` : String(o || '');
      if (RUIDO.test(`${vals} ${ot}`)) return null; // descarta ruido de red/offline
      // Nunca enviar identidad ni cuerpos: solo tenant_id y rol como etiquetas.
      delete event.user;
      if (event.request) {
        delete event.request.data; delete event.request.cookies;
        delete event.request.headers; delete event.request.query_string;
      }
      return event;
    },
  });
  aplicarContexto();
}

// Contexto sin PII: solo tenant_id y rol (nunca correo ni datos de stock).
export function aplicarContexto() {
  if (!dsn) return;
  try {
    const obj = JSON.parse(localStorage.getItem('hueco-tenant-obj') || 'null');
    Sentry.setTag('tenant_id', String(obj?.tenant_id || 'sin_tenant'));
    Sentry.setTag('rol', String(obj?.rol || 'desconocido'));
  } catch (_) { /* noop */ }
}

export { Sentry };
